export const BUDGET_TEMPLATE_PROFILES = [
  {
    id: "new_form",
    label: "Новая форма 2026",
    workbook: "Новая форма_Бюджет 2026.xlsx",
    description: "Текущий профиль /budget",
    defaultTab: "new_form",
    tabs: [
      {
        id: "new_form",
        label: "Новая форма",
        sheet: "Новая форма",
        range: "A1:R81",
        freeze: { row: 3, column: 3, cell: "C3" }
      }
    ]
  },
  {
    id: "budget_no_vat_x_2026",
    label: "Бюджет без НДС Х 2026",
    workbook: "Бюджет без НДС Х 2026 для автоматизации.xlsx",
    description: "Итоговый бюджет по шаблону без НДС",
    defaultTab: "budget",
    tabs: [
      {
        id: "budget",
        label: "Бюджет MICE без НДС 2026",
        sheet: "Бюджет MICE без НДС 2026",
        range: "A1:W426",
        previewRange: "A1:W120",
        freeze: { row: 46, column: 7, cell: "G46" }
      },
      {
        id: "a10",
        label: "А10",
        sheet: "А10",
        range: "A1:AB136",
        previewRange: "A1:AB90",
        freeze: { row: 1, column: 1 }
      }
    ]
  }
];

export function getBudgetTemplateProfile(profileId) {
  return BUDGET_TEMPLATE_PROFILES.find((profile) => profile.id === profileId) || BUDGET_TEMPLATE_PROFILES[0];
}

export function getBudgetTemplateTab(profileId, tabId) {
  const profile = getBudgetTemplateProfile(profileId);
  return profile.tabs.find((tab) => tab.id === tabId) || profile.tabs.find((tab) => tab.id === profile.defaultTab) || profile.tabs[0];
}

export function coerceBudgetTemplateState(profileId, tabId) {
  const profile = getBudgetTemplateProfile(profileId);
  const tab = getBudgetTemplateTab(profile.id, tabId);
  return { profileId: profile.id, tabId: tab.id };
}

export function budgetTemplateRequestPayload(campaignId, includedRequestIds, profileId, tabId) {
  const state = coerceBudgetTemplateState(profileId, tabId);
  const tab = getBudgetTemplateTab(state.profileId, state.tabId);
  return {
    campaign_id: Number(campaignId),
    included_request_ids: includedRequestIds || [],
    template_id: state.profileId,
    sheet: tab.sheet
  };
}

export function budgetTemplateExportQuery(profileId, tabId) {
  const state = coerceBudgetTemplateState(profileId, tabId);
  const tab = getBudgetTemplateTab(state.profileId, state.tabId);
  return {
    template_id: state.profileId,
    sheet: tab.sheet
  };
}

export function rowsForBudgetTemplateTab(preview, profileId, tabId) {
  const rows = preview?.template?.rows || [];
  const { profileId: nextProfileId, tabId: nextTabId } = coerceBudgetTemplateState(profileId, tabId);
  if (nextProfileId !== "budget_no_vat_x_2026") return rows;
  if (nextTabId !== "a10") return rows;
  const a10Rows = rows.filter((row) => (row.article_codes || []).some((code) => String(code).startsWith("A.10")));
  // A non-A10 row is not a substitute for atomic A10 evidence. The backend
  // exposes A10_ATOMIC_DETAIL_UNAVAILABLE when the source does not contain it.
  return a10Rows;
}

function sheetName(sheet) {
  return sheet?.sheet || sheet?.name || sheet?.title || sheet?.label || sheet?.id || "";
}

function sheetIdFor(profile, sheet) {
  const name = sheetName(sheet);
  const known = profile.tabs.find((tab) => tab.sheet === name || tab.label === name || tab.id === sheet?.id);
  return known?.id || sheet?.id || name;
}

function tabsFromResponse(data, profile) {
  if (!Array.isArray(data?.sheets) || !data.sheets.length) return profile.tabs;
  return data.sheets.map((sheet) => {
    const id = sheetIdFor(profile, sheet);
    const known = profile.tabs.find((tab) => tab.id === id || tab.sheet === sheetName(sheet));
    return {
      id,
      label: sheet.label || sheet.title || sheetName(sheet),
      sheet: sheetName(sheet),
      range: sheet.range || sheet.used_range || known?.range || "A1:A1",
      freeze: sheet.freeze || sheet.frozen_panes || known?.freeze
    };
  });
}

function activeSheetFromResponse(data, profile, tab) {
  const sheets = Array.isArray(data?.sheets) ? data.sheets : [];
  const activeSheetName = data?.active_sheet || tab.sheet;
  return sheets.find((sheet) => sheetIdFor(profile, sheet) === tab.id)
    || sheets.find((sheet) => sheetName(sheet) === activeSheetName)
    || sheets.find((sheet) => sheetName(sheet) === tab.sheet)
    || null;
}

export function adaptBudgetTemplateViewData(data, preview, profileId, tabId) {
  void preview;
  const profile = getBudgetTemplateProfile(profileId);
  const tab = getBudgetTemplateTab(profile.id, tabId);
  const activeSheet = activeSheetFromResponse(data, profile, tab);
  const tabs = tabsFromResponse(data, profile);
  return {
    ...data,
    profile_id: profile.id,
    tab_id: tab.id,
    active_template: data?.active_template || { id: profile.id, label: profile.label },
    source_workbook: data?.source_workbook || data?.active_template?.workbook || profile.workbook,
    sheet: sheetName(activeSheet) || data?.sheet || data?.active_sheet || tab.sheet,
    range: activeSheet?.range || activeSheet?.used_range || data?.range || tab.range,
    freeze: activeSheet?.freeze || activeSheet?.frozen_panes || data?.freeze || tab.freeze,
    dimensions: activeSheet?.dimensions || data?.dimensions || {},
    cells: activeSheet?.cells || data?.cells || [],
    tabs
  };
}
